import { Text, Box } from "theme-ui";

import ModalCenter from "../ModalCenter";
import * as styles from "./ModalInfo.styles";

export default function ModalInfo({ isTopMostModal, onClose, title, text }) {
  return (
    <ModalCenter onClose={onClose} isTopMostModal={isTopMostModal}>
      <Box sx={styles.contentContainer}>
        <Text variant="h4Light" sx={styles.modalTitle}>
          {title}
        </Text>
        <Text
          variant="copy2Medium"
          sx={styles.modalTextContent}
          dangerouslySetInnerHTML={{ __html: text }}
        ></Text>
      </Box>
    </ModalCenter>
  );
}
